import type { TermDetail } from '../signup/SignupForm'

import PrivacyPolicy from '@/assets/PrivacyPolicy'
import TermsOfUse from '@/assets/TermsOfUse'

// Placeholder for Lucide ArrowLeft or use inline SVG
const ArrowLeftIcon = () => (
  <svg className='h-5 w-5 text-gray-600' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
    <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M10 19l-7-7m0 0l7-7m-7 7h18' />
  </svg>
)

interface TermDetailModalProps {
  term: TermDetail | null
  isOpen: boolean
  onClose: () => void
}

export function TermDetailModal({ term, isOpen, onClose }: TermDetailModalProps) {
  if (!isOpen || !term) return null

  return (
    <div className='fixed inset-0 z-[70] flex items-center justify-center bg-black bg-opacity-50 p-4'>
      <div className='bg-gradient-to-tl from-[#FEFBE8] to-white rounded-lg w-full max-w-md md:max-w-lg h-[80vh] flex flex-col overflow-hidden'>
        <div className='px-4 py-3 border-b border-gray-200 flex items-center'>
          <button
            onClick={onClose}
            className='p-2 rounded-full hover:bg-gray-200 transition-colors focus:outline-none focus:ring-2 focus:ring-[#FFA236]'
            aria-label='뒤로가기'
          >
            <ArrowLeftIcon />
          </button>
          <h2 className='text-lg font-medium ml-2 text-gray-800'>{term.title}</h2>
        </div>
        <div className='flex-1 px-6 py-4 overflow-y-auto'>
          {term.title === '개인정보 취급방침' ? <PrivacyPolicy /> : <TermsOfUse />}
        </div>
        <div className='px-6 py-4 border-t border-gray-200'>
          <button
            onClick={onClose}
            className='w-full py-3 bg-[#FFA236] text-white rounded-xl font-medium hover:bg-[#EE9A30] transition-colors focus:outline-none focus:ring-2 focus:ring-[#FFA236] focus:ring-offset-2'
          >
            확인
          </button>
        </div>
      </div>
    </div>
  )
}
